import { Box, Container } from './styles'
import CancelButton from '../CancelButton'
import SaveButton from '../SaveButton'
import ClaimActionBarHook from '@/components/feature/HealthClaimDetailPage/ClaimActionBar/ClaimActionBar.hook'

function ClaimActionBar() {
  const { healthClaim, isCreateOrEditMode, getAvailableButtons } = ClaimActionBarHook()

  // Skip rendering only when we are in view mode without loaded data.
  if (!isCreateOrEditMode && !healthClaim.data) {
    return null
  }

  return (
    <>
      {isCreateOrEditMode ? (
        <Container>
          <CancelButton />
          <SaveButton />
        </Container>
      ) : (
        <Container>
          {getAvailableButtons().map((button, i) => (
            <Box key={i}>{button}</Box>
          ))}
        </Container>
      )}
    </>
  )
}

export default ClaimActionBar
